module.exports = __webpack_public_path__ + "media/bootstrap-icons/list-b8fa93e0.svg";